<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-7 col-12 py-2" >
                <div class="border rounded py-2 container-fluid">
                    <h4 class="text-left" >Recebimentos pendentes</h4>
                    <hr>

                    <grid
                        controllers='false' 
                        :titles='grid.titles'
                        :data='grid.content'
                        current-sort="id"
                        @clicked="onClickEvent"
                    />
                </div>
            </div>
            <div class="col-md-5 col-12 py-2" >
                <div class="accordion" id="movimentDetailsAccordion">
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Informações do Cliente
                                </button>
                            </h2>
                        </div>

                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#movimentDetailsAccordion">
                            <div class="card-body">
                                <form>
                                    <div class="form-row">
                                        <div class="col-12 col-md-4 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label >Identificador</label>
                                                <input type="text" v-model="info.cliente.id" class="form-control" disabled placeholder="Identificador" >
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-8 col-lg-8 col-xl-8">
                                            <div class="form-group">
                                                <label >Nome</label>
                                                <input type="text" v-model="info.cliente.nome" class="form-control" disabled placeholder="Documento" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                            <div class="form-group">
                                                <label >Quantidade Créditos</label>
                                                <input type="text" v-model="info.cliente.creditoQuantidade" class="form-control" disabled placeholder="Mora ao dia" >
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                            <div class="form-group">
                                                <label >Total Créditos</label>
                                                <input type="text" v-model="info.cliente.creditoTotal" class="form-control" disabled placeholder="Juros / Descontos" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-12 col-md-6 col-lg-6 col-xl-4">
                                            <div class="form-group">
                                                <label >Limite crédito</label>
                                                <input type="text" v-model="info.cliente.creditoLimite" class="form-control" disabled placeholder="Pago capital" >
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6 col-lg-6 col-xl-4">
                                            <div class="form-group">
                                                <label >Limite utilizado</label>
                                                <input type="text" v-model="info.cliente.creditoUsado" class="form-control" disabled placeholder="Total pago" >
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-12 col-xl-4">
                                            <div class="form-group">
                                                <label >Limite disponivel</label>
                                                <input type="text" v-model="info.cliente.creditoDisponivel" class="form-control" disabled placeholder="Total pago" >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12 col-md-6 col-lg-6 col-xl-4">
                                            <div class="form-group">
                                                <label >Limite vencidos</label>
                                                <input type="text" v-model="info.cliente.creditoVencido" class="form-control" disabled placeholder="Pago capital" >
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6 col-lg-6 col-xl-4">
                                            <div class="form-group">
                                                <label >Limite a vencer</label>
                                                <input type="text" v-model="info.cliente.creditoVencer" class="form-control" disabled placeholder="Total pago" >
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-12 col-xl-4">
                                            <div class="form-group">
                                                <label >Total de limite</label>
                                                <input type="text" v-model="info.cliente.limiteTotal" class="form-control" disabled placeholder="Total pago" >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label >Data do último atraso</label>
                                        <input type="text" v-model="info.cliente.ultimoAtraso" class="form-control" disabled placeholder="Data do pagamento" >
                                    </div>

                                    <!-- <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label >Quantidade</label>
                                                <input type="text" v-model="movimentInfo.pagamento" class="form-control" disabled placeholder="Pagamento no caixa" >
                                            </div>
                                        </div>
                                        <div class="col"> -->
                                    <div class="form-group">
                                        <label >Média</label>
                                        <input type="text" v-model="info.cliente.creditoMedia" class="form-control" disabled placeholder="Forma de pagamento" >
                                    </div>
                                        <!-- </div>
                                    </div> -->
                                </form>                                
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header" id="headingTwo">
                            <h2 class="mb-0">
                                <button class="btn collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    Informações da duplicata
                                </button>
                            </h2>
                        </div>
                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#movimentDetailsAccordion">
                            <div class="card-body">
                                <form>
                                    <div class="form-row">
                                        <div class="col-4">
                                            <div class="form-group">
                                                <label >Identificador</label>
                                                <input type="text" v-model="info.movimento.id" class="form-control" disabled placeholder="Identificador" >
                                            </div>
                                        </div>
                                        <div class="col-8">
                                            <div class="form-group">
                                                <label >Documento</label>
                                                <input type="text" v-model="info.movimento.doc" class="form-control" disabled placeholder="Documento" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label >Mora ao mês</label>
                                                <input type="text" v-model="info.movimento.mora" class="form-control" disabled placeholder="Mora ao dia" >
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label >Juros</label>
                                                <input type="text" v-model="info.movimento.juros" class="form-control" disabled placeholder="Juros / Descontos" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label >Pago capital</label>
                                                <input type="text" v-model="info.movimento.pagoCap" class="form-control" disabled placeholder="Pago capital" >
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label >Total pago</label>
                                                <input type="text" v-model="info.movimento.pagoTot" class="form-control" disabled placeholder="Total pago" >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label >Data do pagamento</label>
                                        <input type="text" v-model="info.movimento.dataPag" class="form-control" disabled placeholder="Data do pagamento" >
                                    </div>
                                    <div class="form-group">
                                        <label >Conta financeira</label>
                                        <input type="text" v-model="info.movimento.conta" class="form-control" disabled placeholder="Conta financeira" >
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                            <div class="form-group">
                                                <label >Pagamento no</label>
                                                <input type="text" v-model="info.movimento.pagamento" class="form-control" disabled placeholder="Pagamento no caixa" >
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                            <div class="form-group">
                                                <label >Forma de pagamento</label>
                                                <input type="text" v-model="info.movimento.forma" class="form-control" disabled placeholder="Forma de pagamento" >
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import grid from '@/components/grid.vue'
    export default {
        name: 'toReceiveView',
        components: {
            grid
        },
        data(){
            return {
                grid: {
                    titles  : [
                        'Id',
                        'Documento',
                        'Parcela',
                        'Dias atrazo',
                        'Mora mês',
                        'Juros',
                        'Valor',
                        'Pago',
                        'Saldo',
                        'Vencimento',
                        'Nota Fiscal',
                        'Tipo',
                        'Seleciona',
                        'Conta'
                    ],
                    content : []
                },

                info: {
                    cliente: {
                        id: 0,
                        nome: 'Cliente',
                        creditoQuantidade: 0,
                        creditoTotal: 'R$ 0.00',
                        creditoLimite: 'R$ 0.00',
                        creditoUsado: 'R$ 0.00',
                        creditoDisponivel: 'R$ 0.00',
                        creditoVencido: 'R$ 0.00',
                        creditoVencer: 0,
                        creditoMedia: 0,
                        limiteTotal: 'R$ 0.00',
                        ultimoAtraso: '10/04/1997'
                    },

                    movimento: {
                        id: 0,
                        doc: 0,
                        mora: 'R$ 0.00',
                        juros: 'R$ 0.00',
                        pagoCap: 'R$ 0.00',
                        pagoTot: 'R$ 0.00',
                        dataPag: '10/04/1997',
                        conta: 'Conta',
                        pagamento: 'Caixa',
                        forma: 'Cartão'
                    }
                }
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            getData: function(){
                fetch(server + 'grides/contas/receber', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    }),
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        this.grid.content = responseJSON.response
                    })
                    .catch(error => {
                        console.error('Error exception', '=>', error.code)
                    })
            },

            onClickEvent: function(value){
                fetch(server + 'grides/contas/receber/' + value.dp_id, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    }),
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        let data = responseJSON.response[0]

                        this.info = {
                            cliente: {
                                id: data.cliente_id,
                                nome: data.cliente_nome,
                                creditoQuantidade: 0,
                                creditoTotal: data.cliente_saldo,
                                creditoLimite: data.cliente_limite,
                                creditoUsado: data.cliente_limite_utilizado,
                                creditoDisponivel: data.cliente_limite_disponivel,
                                creditoVencido: data.cliente_atrasos,
                                creditoVencer: 0,
                                creditoMedia: data.cliente_media_atraso,
                                limiteTotal: 'R$ 0.00',
                                ultimoAtraso: data.cliente_ultimo_atraso
                            },

                            movimento: {
                                id: data.dp_id,
                                doc: data.dp_documento,
                                mora: data.dp_mora_mes,
                                juros: data.dp_juros,
                                pagoCap: data.dp_pago,
                                pagoTot: data.dp_valor,
                                dataPag: data.dp_vencimento,
                                conta: data.dp_conta,
                                pagamento: 'Caixa',
                                forma: 'Cartão'
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error exception', '=>', error.code)
                    })
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>